import { HttpErrorResponse } from '@angular/common/http';
import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Subject, switchMap } from 'rxjs';
import { BookshelfAPIService } from 'shared/services';
import { ToastService, TypedDialog } from 'shared/ui';

@Component({
  selector: 'lib-edit-bookshelf',
  templateUrl: './edit-bookshelf.component.html',
  styleUrl: './edit-bookshelf.component.scss',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'mobile-full-height' },
})
export class EditBookshelfComponent
  extends TypedDialog<
    { bookshelf_id: string; bookshelf_name: string; is_private: number },
    { canceled: 'success' | 'failed' }
  >
  implements OnInit, OnDestroy
{
  private _EditBookshelfSubject = new Subject<void>();
  private _submitLoadingIndicatorTimer: ReturnType<typeof setTimeout> | null =
    null;

  public _inputBookshelfValue: string = '';
  public _isPublic: number = this._data.is_private;
  public _bookshelfName = this._data.bookshelf_name;
  public _isSaving = false;
  public _showSubmitLoadingIndicator = false;

  constructor(
    private _bookshelfAPIService: BookshelfAPIService,
    private _toastService: ToastService,
    private _ngZone: NgZone
  ) {
    super();
  }

  ngOnInit(): void {
    this._EditBookshelfSubject
      .pipe(
        switchMap(() => {
          return this._bookshelfAPIService.changeBookshelf(
            this._data.bookshelf_id,
            this._inputBookshelfValue,
            this._isPublic
          );
        })
      )
      .subscribe({
        next: () => {
          this._clearSubmitLoadingIndicatorTimer();
          this._toastService.open('책장명 변경이 완료되었습니다.');
          this._dialogRef.close({ canceled: 'success' });
        },
        error: (error: HttpErrorResponse) => {
          this._clearSubmitLoadingIndicatorTimer();
          this._isSaving = false;
          this._showSubmitLoadingIndicator = false;
          this._toastService.open(
            `오류가 발생했습니다. 잠시 후 다시 시도해주세요. (${error.status})`
          );
        },
      });
  }

  ngOnDestroy(): void {
    this._clearSubmitLoadingIndicatorTimer();
    this._EditBookshelfSubject.complete();
  }

  public _closeDialog(): void {
    this._dialogRef.close();
  }

  public _changeIsPublic(event: any): void {
    if (event.srcElement.checked) {
      this._isPublic = 1;
    } else {
      this._isPublic = 0;
    }
  }

  public _onClickSubmit(): void {
    if (this._isSaving) {
      return;
    }

    this._clearSubmitLoadingIndicatorTimer();
    this._showSubmitLoadingIndicator = false;
    this._isSaving = true;
    this._submitLoadingIndicatorTimer = setTimeout(() => {
      this._submitLoadingIndicatorTimer = null;
      this._ngZone.run(() => {
        if (this._isSaving) {
          this._showSubmitLoadingIndicator = true;
        }
      });
    }, 1000);

    this._EditBookshelfSubject.next();
  }

  private _clearSubmitLoadingIndicatorTimer(): void {
    if (this._submitLoadingIndicatorTimer !== null) {
      clearTimeout(this._submitLoadingIndicatorTimer);
      this._submitLoadingIndicatorTimer = null;
    }
  }
}
